export enum CompetitionRuleset {
	Wsm2023 = 1,
	Wsm2026 = 3,
	Asc2023 = 2,
}
